var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExitFullscreen = function SvgExitFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.4 11.4H4L0 15.4L1.4 16.8L5.4 12.8V16.4H7.4V9.4H0.4V11.4ZM15.4 0L11.4 4V0.4H9.4V7.4H16.4V5.4H12.8L16.8 1.4L15.4 0Z",
    fill: "currentColor"
  })));
};
export default SvgExitFullscreen;